import { useState } from 'react';
import { FiMenu, FiX } from "react-icons/fi";
import { Sun, Moon } from "lucide-react";
import NavModal from './NavModal';
import { useTheme } from 'context/ThemeContext';

type Props = {
    wrapperStyle?: string;
    logoImg?: string;
    floating?: boolean;
}

const MobileNav = (props: Props) => {
    const [modalState, setModalState] = useState(false);
    const { theme, toggleTheme } = useTheme();

    const scrollToTop = () => {
        setModalState(false);
        document.getElementById('Home')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            <div className={`${props.wrapperStyle} !px-5 w-full hidden justify-between items-center gap-10 shadow-[0_8px_30px_rgb(0,0,0,0.12)]`} style={{ background: theme === 'dark' ? undefined : '#ffffff' }}>
                <button
                    type="button"
                    onClick={scrollToTop}
                    aria-label="Back to top"
                    className='nav_title_text text-Primary text-xl flex justify-center items-center'
                >
                    H@A
                </button>
                <div className="flex items-center gap-3">
                    <button
                        type="button"
                        onClick={toggleTheme}
                        aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                        className='flex items-center justify-center w-8 h-8 rounded-full'
                        style={{
                            color: theme === 'dark' ? 'rgba(255,255,255,0.6)' : 'rgba(0,0,0,0.5)',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                    </button>
                    <button
                        type="button"
                        onClick={() => setModalState((open) => !open)}
                        aria-label={modalState ? 'Close menu' : 'Open menu'}
                        aria-expanded={modalState}
                        aria-controls="mobile-nav-panel"
                        className='flex items-center justify-center'
                    >
                        {modalState
                            ? <FiX className='text-Primary w-8 h-8 transition ease-in-out duration-250' />

                            : <FiMenu className='text-Primary w-8 h-8 transition ease-in-out duration-250' />}
                    </button>
                </div>
            </div>
            {modalState && <NavModal setModalState={setModalState} />}
        </>
    )
}

export default MobileNav;
